export default __webpack_public_path__ + "static/media/(22).40739ad3.jpeg";